module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tabbar"
  }, [_c('router-link', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "to": "/note"
    }
  }, [_c('img', {
    staticClass: "weui-tabbar__icon",
    attrs: {
      "src": require("../assets/img/icon_nav_layout.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("Note")])]), _vm._v(" "), _c('router-link', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "to": "/tool"
    }
  }, [_c('img', {
    staticClass: "weui-tabbar__icon",
    attrs: {
      "src": require("../assets/img/icon_nav_search.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("Tool")])]), _vm._v(" "), _c('router-link', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "to": "/stock"
    }
  }, [_c('img', {
    staticClass: "weui-tabbar__icon",
    attrs: {
      "src": require("../assets/img/icon_nav_search.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("Stock")])]), _vm._v(" "), _c('router-link', {
    staticClass: "weui-tabbar__item",
    attrs: {
      "to": "/info"
    }
  }, [_c('img', {
    staticClass: "weui-tabbar__icon",
    attrs: {
      "src": require("../assets/img/icon_nav_nav.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("Discovery")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f01362","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 556
// module chunks = 1